import { createElement as h } from "react"
import { useSelector } from "react-redux"
import { Helmet } from "react-helmet"

import * as LocalizationModel from "../model/localization.js"

export const LocaleProvider = () => {
  const { defaultContentLocale } = useSelector(LocalizationModel.selectors.locales)

  return h(Helmet, { htmlAttributes: { lang: defaultContentLocale.shorthand, translate: "no" } })
}
